import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { DeductibleExpense, LocalTaxMode, TaxEstimationMode } from './useTaxesQuery';
import { queryKeys } from './queryKeys';

export const SAVA_TAXES_MK = 'saveTaxesMK';

export interface SaveTaxesBody {
  taxEstimationMode: TaxEstimationMode;
  postRetirementtaxEstimationMode: TaxEstimationMode;
  localTaxMode: LocalTaxMode;
  postRetirementLocalTaxMode: LocalTaxMode;
  percentageLocalTax: number;
  postRetirementPercentageLocalTax: number;
  flatLocalTax: number;
  postRetirementFlatLocalTax: number;
  effectiveTaxRate: number;
  postRetirementEffectiveTaxRate: number;
  useDifferentPostRetirementTaxes: boolean;
  postRetirementSelectedFilingState: number;
  useStandardDeductions: boolean;
  itemizedDeductibleExpenses: DeductibleExpense[];
}

interface FetcherParams {
  clientId: string;
  body: SaveTaxesBody;
}

const saveTaxes = ({ clientId, body }: FetcherParams) => {
  return authFetch('/Consumer/TaxFilingUpdate/Save', {
    method: 'POST',
    ...httpBodyOptions({ clientId, ...body }),
  });
};

interface MutationParams {
  clientId: string;
  stepId?: string;
}

export const useSaveTaxesMutation = ({ clientId, stepId }: MutationParams) => {
  const queryClient = useQueryClient();

  return useMutation(saveTaxes, {
    mutationKey: SAVA_TAXES_MK,

    async onSuccess() {
      await queryClient.refetchQueries(queryKeys.taxes(clientId, stepId));
    },
  });
};
